"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TEAM_ACTIVITY = void 0;
var TEAM_ACTIVITY = {
  BUTTON__SELECT_ACCOUNT_REP: 'crmTeamActivity-button-selectAccountRepresentative',
  BUTTON__SELECT_TYPE: 'crmTeamActivity-button-selectType',
  BUTTON__SELECT_OUTLET: 'crmTeamActivity-button-selectOutlet',
  BUTTON__SELECT_DATE: 'crmTeamActivity-button-selectDate',
  BUTTON__ADD_ACTIVITY: 'crmTeamActivity-button-activity',
  TEXT__ACCOUNT_REP: 'crmTeamActivity-span-accountRepresentative',
  TEXT__TYPE: 'crmTeamActivity-span-activityType',
  TEXT__OUTLET: 'crmTeamActivity-span-outlet',
  TEXT__DATE: 'crmTeamActivity-span-date',
  TEXT__NOTE: 'crmTeamActivity-span-note'
};
exports.TEAM_ACTIVITY = TEAM_ACTIVITY;